import { Button, CircularProgress, Grid } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import "../style.css";

const ActionFooter = ({
  primaryLabel,
  secondaryLabel,
  onPrimaryAction,
  onSecondaryAction,
  disablePrimary,
  disableSecondary,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  return (
    <Grid
      container
      className="column-gap-8"
      justifyContent="flex-end"
      wrap="nowrap"
    >
      <Button
        variant="outlined"
        className="setting-btn-secondary"
        disabled={disableSecondary || isLoading}
        onClick={onSecondaryAction}
      >
        {secondaryLabel ?? t("common.cancel")}
      </Button>
      <Button
        variant="contained"
        className="setting-btn-primary"
        disabled={disablePrimary || isLoading}
        onClick={onPrimaryAction}
      >
        {isLoading && (
          <CircularProgress size={15} className="color-white" />
        )}
        {primaryLabel ?? t("common.save")}
      </Button>
    </Grid>
  );
};

export default ActionFooter;
